import React from 'react'
import { Create } from 'react-admin'
import TournamentForm from './TournamentForm'
import Toolbar from '../../components/FormToolbar'
import { configureTornamentBeforeRecord, uploadFile } from '../utils'

const CreateTournament = (props) => {
  const transform = async (data) => {
    if (data.poster?.rawFile instanceof File) {
      data.poster = await uploadFile(data.poster)
    }

    configureTornamentBeforeRecord(data)
    const { facsimile, ...rest } = data
    return rest
  }

  return (
    <Create
      {...props}
      toolbar={<Toolbar />}
      title='Создание турнира'
      transform={transform}
    >
      <TournamentForm {...props} />
    </Create>
  )
}

export default CreateTournament
